const BrochureProgressStatus={
	Queued:1,
	Generating:2,
	Generated:3
};
BrochureProgressStatus.getClassName = function(brochureProgressStatus){
	switch(brochureProgressStatus){
		case BrochureProgressStatus.Queued:
			return 'queued';
		case BrochureProgressStatus.Generating:
			return 'generating';
		case BrochureProgressStatus.Generated:
			return 'generated';
		default:
			throw new Error('Not implemented');
	}
};
export default BrochureProgressStatus;